<div class="pos-relative">
    <button class="no-wrap va-m"
            type="button"
            (click)="openShareIcons()">
        <i class="inline-block va-m p-r-1 icon-share"
           [style.font-size.px]="20"
           aria-hidden="true"></i>
        <p class="inline-block">{{'Share' | translate}}</p>
    </button>

    <div class="pos-absolute left-0 m-t-1-s p-t-1 p-b-1 p-r-1 p-r-2-s b-a b-radius-max bg-col-w share-icons__wrapper"
         [class.is-open]="shareIconsVisible"
         role="button"
         (click)="closeShareIcons()">
        <div class="p-r-1 p-l-1 flex">
            <button class="m-r-2 fs-5 col-13 link icon-facebook share-icons__icon"
                    style="--share-icon-index: 0"
                    (click)="fbShare()"
                    type="button"
                    aria-label="Share by Facebook"></button>
            <button class="m-r-2 fs-5 col-13 link icon-twitter share-icons__icon"
                    style="--share-icon-index: 1"
                    (click)="twShare()"
                    type="button"
                    aria-label="Share by Twitter"></button>
            <button class="m-r-2 fs-5 col-13 link icon-pinterest share-icons__icon"
                    style="--share-icon-index: 2"
                    (click)="pinShare()"
                    type="button"
                    aria-label="Share by Pinterest"></button>
            <a class="fs-5 col-13 link icon-email share-icons__icon"
               style="--share-icon-index: 3"
               [attr.href]="shareByEmail"><span class="sr-only">{{'Share by email' | translate}}</span>
            </a>
        </div>
    </div>
</div>